import axios from 'axios'
const API_URL = 'https://www.uptodateconnect.com/api/v1';

export const api = {
  get: async link => {
    return await axios.get(`${API_URL}/${link}`)
  },
  post: async (link, payload) => {
    return await axios.post(
      `${API_URL}${link}`,
      payload,
    )
  },
  put: async (link, payload) => {
    return await axios.put(
      `${API_URL}${link}`,
      payload,
    )
  },
  delete: async link => {
    return await axios.delete(`${API_URL}/${link}`)
  },
  patch: async (link, payload) => {
    return await axios.patch(
      `${API_URL}${link}`,
      payload
    )
  },
  axios: axios,
}
